import { BehaviorSubject } from 'rxjs';
import { Injectable, Input } from '@angular/core';

@Injectable()
export class Globals {

  //public pageName = '{Page Name}';
  public pageName: BehaviorSubject<String> = new BehaviorSubject<String>("Settings");
  public displayHeader: boolean = true;
  public backButtonDefaultHref: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

  public locale: string = navigator.language || 'en-US';

  public isLoadingSubject$ = new BehaviorSubject<boolean>(false);
  public isLoading$ = this.isLoadingSubject$.asObservable();
  public loadingRequestCount = 0;
  //isLoading: boolean = false;

  public isLoadingArray$ = new Map();
  public isLoadingArrSubject$ = new BehaviorSubject<Map<string,number>>(new Map());
  public isLoadingArr$ = this.isLoadingArrSubject$.asObservable();

  incrementLoadingArr(urlPath: string){
    if (this.isLoadingArray$[urlPath] === undefined) {
      this.isLoadingArray$[urlPath] = 0;
    }
    this.isLoadingArray$[urlPath]++;
    this.isLoadingArrSubject$.next(this.isLoadingArray$);
  }

  decrementLoadingArr(urlPath: string){
    if (this.isLoadingArray$[urlPath] === undefined) {
      this.isLoadingArray$[urlPath] = 0;
    }
    this.isLoadingArray$[urlPath]--;
    this.isLoadingArrSubject$.next(this.isLoadingArray$);
    //console.log('isLoadingArr:',this.isLoadingArr$.forEach.toString);
  }

  setIsLoading(b: boolean){
   this.isLoadingSubject$.next(b);
  }

  recalcIsLoading(){
    //console.log('loadingRequestCount',this.loadingRequestCount)
    if (this.loadingRequestCount > 0)
      this.setIsLoading(true);
    else
      this.setIsLoading(false);
  }

  incrementLoadingRequests () {
    this.loadingRequestCount++;
    this.recalcIsLoading();
  }

  decrementLoadingRequests () {
    this.loadingRequestCount--;
    this.recalcIsLoading();
  }

}
